import { Directive, ElementRef, HostListener, Input, OnInit, Renderer2 } from '@angular/core';

// [ --- changelogs --- ]
// new config named 'menuItemClose' added which closes the menu on menu item click
// By default propety is set to true
// to prevent this pass menuItemClose as false in config
@Directive({
  selector: '[bixPopover]'
})
export class BixPopoverDirective implements OnInit {

  @Input() bixTriggerFor: any;

  @Input() bixPopperConfig: bixPopperConfig = {
    disableClose: true,
    position: 'auto',
    menuItemClose: false
  };

  bixPopoverClassName: string = 'bix-popover-';

  bixPopoverContentRef: any = null;

  constructor(private renderer: Renderer2, private el: ElementRef) { }

  ngOnInit() {

    let initializedPopoverList = document.getElementsByClassName('bix-popover-toggler');

    this.renderer.addClass(this.el.nativeElement, 'bix-popover-toggler');

    this.renderer.addClass(this.el.nativeElement, 'bix-popover-' + initializedPopoverList.length);

    this.bixPopoverClassName = this.bixPopoverClassName + initializedPopoverList.length;


    for (let child of this.el.nativeElement.children) {
      this.renderer.addClass(child, 'bix-popover-' + initializedPopoverList.length);
    }

    let newBixPopoverContainer = this.renderer.createElement('div');

    let newBixPopoverContent = this.renderer.createElement('div');

    newBixPopoverContent.id = 'bixPopoverContent';

    this.renderer.addClass(newBixPopoverContent, 'bix-popover-content');


    newBixPopoverContainer.id = 'bixPopover';

    this.renderer.addClass(newBixPopoverContainer, 'bix-popover-container');
    this.renderer.addClass(newBixPopoverContainer, 'bix-popover-' + initializedPopoverList.length);

    let popoverHandleImg = this.renderer.createElement("img");
    popoverHandleImg.src = 'assets/images/dropdown_circle.svg';
    popoverHandleImg.style.zIndex = 5002;

    this.renderer.addClass(popoverHandleImg, 'bix-popover-handle');

    this.renderer.appendChild(newBixPopoverContainer, popoverHandleImg);
    this.renderer.appendChild(newBixPopoverContent, this.bixTriggerFor);

    newBixPopoverContent.style.zIndex = 5001;


    this.renderer.appendChild(newBixPopoverContainer, newBixPopoverContent);


    if (this.bixPopperConfig && this.bixPopperConfig.disableClose == true) {
      this.addPopoverBackdrop(newBixPopoverContainer);
    }


    this.bixPopoverContentRef = newBixPopoverContainer;

    // this.bixTriggerFor.remove();

    if(!this.bixPopperConfig.hasOwnProperty('menuItemClose')) {
      this.bixPopperConfig.menuItemClose = true;
    }
  }


  @HostListener('click', ['$event']) onClick(event: any) {

    let isBixPopoevrActive = document.getElementById('bixPopover');

    if (isBixPopoevrActive !== null) {
      if (isBixPopoevrActive.classList.contains(this.bixPopoverClassName)) {
        isBixPopoevrActive.remove();
      } else {
        isBixPopoevrActive.remove();
        document.body.appendChild(this.bixPopoverContentRef);
        this.repositionXY(this.el.nativeElement.getBoundingClientRect());

        
        if (this.bixPopperConfig.menuItemClose) {
          this.listenPopoverContentClick();
        }
      }
    } else {
      document.body.appendChild(this.bixPopoverContentRef);
      this.repositionXY(this.el.nativeElement.getBoundingClientRect());

      if (this.bixPopperConfig.menuItemClose) {
        this.listenPopoverContentClick();
      }
    }
  }

  listenPopoverContentClick() {
    this.renderer.listen(this.bixPopoverContentRef, 'click', () => {
      let popover = document.getElementById('bixPopover');
      if (popover) {
        popover.remove();

      }
    });
  }



  @HostListener('document:scroll', ['$event'])
  onWindowScroll(event: any) {
    let isBixPopoevrActive: any = document.getElementById('bixPopover');

    if (isBixPopoevrActive !== null) {
      if (isBixPopoevrActive.classList[1] === this.bixPopoverClassName) {
        this.repositionXY(this.el.nativeElement.getBoundingClientRect());
      }
    }
  }

  addPopoverBackdrop(container: any) {
    let newBixPopoverBackdrop = this.renderer.createElement('div');

    this.renderer.addClass(newBixPopoverBackdrop, 'bix-popover-backdrop');

    newBixPopoverBackdrop.style.zIndex = 5000;

    this.renderer.appendChild(container, newBixPopoverBackdrop);

    newBixPopoverBackdrop.addEventListener('click', (event: any) => {
      let isBixPopoevrActive = document.getElementById('bixPopover');
      if (isBixPopoevrActive !== null) {
        isBixPopoevrActive.remove();
      }
    });
  }


  repositionXY(rect: any) {
    let bixPopoverContent = document.getElementById('bixPopoverContent');

    if (bixPopoverContent !== null) {

      let bixPopoverHandle: any = document.getElementsByClassName('bix-popover-handle');

      if (bixPopoverHandle[0]) {
        bixPopoverHandle[0].style.left = (rect.left + (rect.width / 2)) + 'px';

        bixPopoverHandle[0].style.transform = 'translateX(-60%)';

        if (window.innerHeight > (rect.top + rect.height + 10 + bixPopoverContent.offsetHeight)) {
          bixPopoverHandle[0].style.top = ((rect.top + rect.height) - 15 + 10) + 'px';
        } else {
          bixPopoverHandle[0].style.top = ((rect.top - 25)) + 'px';
        }

      }

      // content Y position only auto is available

      if (window.innerHeight > (rect.top + rect.height + 10 + bixPopoverContent.offsetHeight)) {
        bixPopoverContent.style.top = (rect.top + rect.height + 10) + 'px';
      } else {
        bixPopoverContent.style.top = (rect.top - bixPopoverContent.offsetHeight - 10) + 'px';
      }


      if (this.bixPopperConfig && this.bixPopperConfig.position) {
        if (this.bixPopperConfig.position == 'middle') {
          bixPopoverContent.style.left = (rect.left + (rect.width / 2) - (bixPopoverContent.offsetWidth / 2)) + 'px';
        }
        if (this.bixPopperConfig.position == 'before') {
          bixPopoverContent.style.left = rect.left + 'px';
        }
        if (this.bixPopperConfig.position == 'after') {
          bixPopoverContent.style.left = (rect.left + (rect.width) - (bixPopoverContent.offsetWidth)) + 'px';
        }

        if (this.bixPopperConfig.position == 'auto') {
          // bixPopoverContent.style.left = (rect.left + (rect.width / 2) - (bixPopoverContent.offsetWidth / 2)) + 'px';

          if (rect.left > bixPopoverContent.offsetWidth) {
            bixPopoverContent.style.left = (rect.left + (rect.width / 2) - (bixPopoverContent.offsetWidth / 2)) + 'px';
          } else {
            if (rect.right > bixPopoverContent.offsetWidth) {
              bixPopoverContent.style.left = (rect.left + (rect.width) - (bixPopoverContent.offsetWidth)) + 'px';
            } else {
              bixPopoverContent.style.left = rect.left + 'px';
            }
          }
        }
      }

      // commented cuz by default position is auto
      // else {
      //   bixPopoverContent.style.left = (rect.left + (rect.width / 2) - (bixPopoverContent.offsetWidth / 2)) + 'px';
      // }
    }
  }



}


export interface bixPopperConfig {
  disableClose?: boolean;
  position?: popperPosition;
  menuItemClose?: boolean;
}


export declare type popperPosition = 'top' | 'before' | 'middle' | 'after' | 'auto';
